import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { deepQuotes } from '../data/content';
export function Testimonials() {
  return <Section tone="white" eyebrow="Testimonios" title="Historias reales de impacto" data-id="element-169" data-mp="3fznrfeogiyy7">
      <ul className="mx-auto max-w-narrow divide-y divide-gray-200" data-id="element-170" data-mp="3fxb4so7r80et">
        {deepQuotes.map(quote => <li key={`${quote.author}-${quote.city}`} className="grid gap-4 py-8 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,14rem)_1fr] md:gap-10" data-id="element-171" data-mp="36yzgwty9vgq2">
            <div className="flex items-start gap-3" data-id="element-172" data-mp="321z6k6ue3rt5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-plum-700 font-display text-xs font-bold text-rose-100" data-id="element-173" data-mp="2x1upaelnqt1v">
                {quote.initials}
              </span>
              <span data-id="element-174" data-mp="v859txg9hd2s">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-175" data-mp="v8nbj9lp0ji3">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-176" data-mp="h5eyxl97hv0o" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-ink" data-id="element-177" data-mp="79bozt844s36">
                  {quote.author}
                </span>
                <span className="block text-sm text-gray-500" data-id="element-178" data-mp="zvweeo512u43">{quote.role}</span>
                <span className="inline-flex items-center gap-1 text-sm text-gray-500" data-id="element-179" data-mp="14vj2jsme9uro">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-180" data-mp="14xdewijloek5" />
                  {quote.city}
                </span>
              </span>
            </div>
            <blockquote className="border-l-4 border-rose-500 pl-5 text-lg leading-relaxed text-ink md:text-xl" data-id="element-181" data-mp="v4emepkzg3v9">
              “{quote.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}